import { ApiResponse, baseUrl, getWithAuth, postWithAuth } from "./baseApi"

export type Client = {
    id: string
    name : string
}

export type GetClientsResponse = {
    clients : Client[]
}

export type CreateClientRequest = {
    name : string,
}

export type CreateClientResponse = {
    id : string,
}

export const getClients = async() : Promise<ApiResponse<GetClientsResponse>> => {
    return await getWithAuth<GetClientsResponse>({url : `${baseUrl}client`});
}

export const createClient = async(request : CreateClientRequest) : Promise<ApiResponse<CreateClientResponse>> => {
    return await postWithAuth<CreateClientRequest,CreateClientResponse>(`${baseUrl}client`, request);
}